import { Injectable, signal } from "@angular/core";
import { ApplicationService, AppSetting, AsService } from "./app-setting.model";
//import appSettingJson from '@public/app-setting.json';

@Injectable({ providedIn: 'root' })
export class AppSettingStore {

  private readonly _appsetting = signal<AppSetting | null>(null);
  private readonly _loading = signal<boolean>(true);

  // exposer les signals en lecture seule
  appsetting = this._appsetting.asReadonly();
  loading = this._loading.asReadonly();

  load() {
    this._loading.set(true);

    //const appsetting = new AppSetting({
    //  authentification: appSettingJson.authentification,
    //  application: new ApplicationService({
    //    name: appSettingJson.application.name,
    //    version: appSettingJson.application.version
    //  }),
    //  service: new AsService({
    //    baseUrl: appSettingJson.service.baseUrl
    //  })
    //})
    //this._appsetting.set(appsetting);

    this._loading.set(false);
  }

}
